// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app {\r\n    margin: 1rem;\r\n    font-family: Arial, Helvetica, sans-serif;\r\n    color: white;\r\n  }", ""]);
// Exports
module.exports = exports;
